import { render, staticRenderFns } from "./CreateStakeholder.vue?vue&type=template&id=352c87aa&scoped=true"
import script from "./CreateStakeholder.vue?vue&type=script&lang=js"
export * from "./CreateStakeholder.vue?vue&type=script&lang=js"
import style0 from "./CreateStakeholder.vue?vue&type=style&index=0&id=352c87aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c87aa",
  null
  
)

export default component.exports